import React from "react";
import { styled } from "@mui/material/styles";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepConnector, { stepConnectorClasses } from "@mui/material/StepConnector";
import { useTranslation } from "react-i18next";
import { colors } from "../../../theme/palette";
import { ActiveStepIcon, InactiveStepIcon, CompletedStepIcon } from "../../../assets/icons/MUI/EventsIcons";

const CustomConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10.5,
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: colors.Green100,
    borderWidth: 3,
  },
  ["& .MuiStepLabel-label"]: {
    color: colors.Dark1000,
    textAlign: "center",
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "normal",
  },
}));

const CustomStepIcon = ({ active, completed }: { active: boolean; completed: boolean }) => {
  if (completed) return <CompletedStepIcon />;
  return active ? <ActiveStepIcon /> : <InactiveStepIcon />;
};

const EventStepper = ({ step }: { step: number }) => {
  const { t } = useTranslation();

  const steps = [
    t("pages.events.createEvent.fillData"),
    t("pages.events.createEvent.selectDateTime"),
    t("pages.events.createEvent.selectParticipants"),
  ];

  return (
    <Stepper
      sx={{
        paddingBottom: "16px",
        borderBottom: `1px solid ${colors.Gray100}`,
        marginBottom: "32px",
      }}
      alternativeLabel
      activeStep={step}
      connector={<CustomConnector />}
    >
      {steps.map((label, index) => (
        <Step key={label}>
          <StepLabel
            StepIconComponent={(props) => (
              <CustomStepIcon active={props.active || false} completed={props.completed || false} />
            )}
            sx={{
              "& .MuiStepLabel-label": {
                color: index < step ? colors.Green100 : "var(--black-80, rgba(28, 28, 28, 0.80))",
                fontWeight: index <= step ? 700 : 600,
              },
            }}
          >
            {label}
          </StepLabel>
        </Step>
      ))}
    </Stepper>
  );
};

export default EventStepper;
